export default __webpack_public_path__ + "static/media/img-0232-netherlands-premium-face.52314f22.png";